var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',[_c('router-link',{attrs:{"to":"/"}},[_c('dr-vector',{staticClass:"footer",attrs:{"src":"@/assets/img/Logo.svg","fill":"white"}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }